import { render } from "./LpaSidebar.vue?vue&type=template&id=1ecfd56e&ts=true"
import script from "./LpaSidebar.vue?vue&type=script&lang=ts"
export * from "./LpaSidebar.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__